import api from "api";

export const getMedicalIncentivesData = (params) => {
  return api.get(
    `/v1/incentive/medical/incentiveAmountWithAchievedScore${params}`
  );
};
export const getMedicalIncentivesFilterData = (params) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `/v1/incentive/medical/incentiveAmountWithAchievedScoreFilters?${queryString}`;
  return api.get(url);
};
